import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {User} from '@app/core/model/user';
import {MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig} from '@angular/material/legacy-snack-bar';
import {MESSAGES} from '@app/core/model/messages';
import {takeUntil} from 'rxjs/operators';
import {AuthenticatedUserService} from '@app/core/service/authenticated-user.service';

@Component({
    selector: 'ngc-totp-mfa-setup',
    templateUrl: './totp-mfa-setup.component.html',
    styleUrls: ['./totp-mfa-setup.component.scss']
})
export class TotpMfaSetupComponent implements OnInit, OnDestroy {

    @Input() loading$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    @Output() cancel = new EventEmitter<void>();
    @Output() success = new EventEmitter<string[]>();

    secretKeyCtrl = new FormControl({value: '', disabled: true});
    user: User;
    uri: string;
    setupForm: FormGroup;
    private unsubscribe$ = new Subject<void>();

    constructor(private authenticatedUserService: AuthenticatedUserService,
                private formBuilder: FormBuilder,
                private snackBar: MatSnackBar
    ) {
    }

    ngOnInit(): void {
        this.setupForm = this.formBuilder.group({
            confirmationKey : [
                '',
                [
                    Validators.required,
                    Validators.minLength(6),
                    Validators.maxLength(6),
                    Validators.pattern(/^[0-9]*$/)
                ]
            ]
        });

        this.loading$.next(true);
        this.authenticatedUserService.getTotpMfaSecret()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(({ secret, uri }: {secret: string; uri: string}) => {
                this.uri = uri;
                this.secretKeyCtrl.setValue(secret);

                this.loading$.next(false);
            }, error => {
                this.snackBar.open(MESSAGES.UNKNOWN_ERROR, 'ERROR', <MatSnackBarConfig>{duration: 3000});
                this.loading$.next(false);
                this.cancel.emit();
            });
    }

    onFormSubmit(form: any) {
        this.enableTotpMfaForUser();
    }

    onCancel() {
        this.cancel.emit();
    }

    onCopySecretKeyToClipboard() {
        this.snackBar.open('Secret Key copied to Clipboard' , '', <MatSnackBarConfig>{duration: 1500});
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    private enableTotpMfaForUser(): void {
        this.loading$.next(true);
        const confirmationKey = this.setupForm.controls.confirmationKey.value;
        this.authenticatedUserService.enableTotpMfaForUser(confirmationKey)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((recoveryCodes: string[]) => {
                this.success.emit(recoveryCodes);
                this.loading$.next(false);
            },
            err => {
                this.snackBar.open(MESSAGES.UNKNOWN_ERROR, 'ERROR', <MatSnackBarConfig>{duration: 2000});
                this.loading$.next(false);
            });
    }
}
